module.exports = __webpack_public_path__ + "static/media/rsyw_jdyf_icon@3x.e1ad1866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rsyw_jdyf_icon@3x.png
// module id = 198
// module chunks = 0